import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import appStateSlice from "./apiSlice/appStateSlice";
import authSlice from "./apiSlice/authSlice";
import examSlice from "./apiSlice/examSlice";
import categorySlice from "./apiSlice/categorySlice";
import productSlice from "./apiSlice/productSlice";
import commonSlice from "./apiSlice/commonSlice";
import requestSlice from "./apiSlice/requestSlice";
import voucherSlice from "./apiSlice/voucherSlice";
import announcementSlice from "./apiSlice/announcementSlice";
import userSlice from "./apiSlice/userSlice";
import financeSlice from "./apiSlice/financeSlice";
import atcSlice from "./apiSlice/atcSlice";
import examinerSlice from "./apiSlice/examinerSlice";
import supportSlice from "./apiSlice/supportSlice";

export const store = configureStore({
  reducer: {
    appState: appStateSlice,
    auth: authSlice,
    exam: examSlice,
    request: requestSlice,
    category: categorySlice,
    product: productSlice,
    atc: atcSlice,
    common: commonSlice,
    voucher: voucherSlice,
    announcement: announcementSlice,
    user: userSlice,
    finance: financeSlice,
    examiner: examinerSlice,
    support: supportSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
